"use client";

import { useEffect, useState } from "react";

import {
  GAM_BASE_DESKTOP_RIGHT_RAIL_AD_UNIT,
  GAM_BASE_DESKTOP_RIGHT_RAIL_ENABLED,
  GAM_BASE_DESKTOP_RIGHT_RAIL_MIN_HEIGHT,
  GAM_BASE_DESKTOP_RIGHT_RAIL_SIZES,
} from "@/components/ads/config";
import GamDisplaySlot from "@/components/ads/GamDisplaySlot";

import styles from "./BaseDesktopRightRailAd.module.css";

type Props = {
  targeting?: Record<string, string | number | boolean | Array<string | number | boolean> | null | undefined>;
};

export default function BaseDesktopRightRailAd({ targeting }: Props) {
  const [show, setShow] = useState<boolean | null>(null);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(min-width: 1280px)");
    const update = () => setShow(mediaQuery.matches);

    update();
    mediaQuery.addEventListener("change", update);
    return () => mediaQuery.removeEventListener("change", update);
  }, []);

  if (!GAM_BASE_DESKTOP_RIGHT_RAIL_ENABLED || show !== true) return null;

  return (
    <aside className={styles.rail} aria-label="Sponsored base page side banner">
      <div className={styles.sticky}>
        <span className={styles.label}>Sponsored</span>
        <GamDisplaySlot
          id="base-desktop-right-rail"
          adUnit={GAM_BASE_DESKTOP_RIGHT_RAIL_AD_UNIT}
          sizes={[...GAM_BASE_DESKTOP_RIGHT_RAIL_SIZES]}
          minHeight={GAM_BASE_DESKTOP_RIGHT_RAIL_MIN_HEIGHT}
          lazyRootMargin="500px 0px"
          targeting={{
            page_type: "base",
            device: "desktop",
            placement: "base_desktop_right_rail_after_hero",
            position: "right_rail_after_hero",
            inventory_tier: "premium_rail",
            ...targeting,
          }}
        />
      </div>
    </aside>
  );
}
